import { normalizeDiscordId } from './discord.js';

const normalizePlayerName = (value) => String(value || '').trim();
const normalizePlayerKey = (value) => normalizePlayerName(value).toLowerCase();

export const normalizePlayer = (row = {}) => ({
  id: row.id,
  name: normalizePlayerName(row.name || row.player || row.player_name),
  discord_id: normalizeDiscordId(row.discord_id),
  created_at: row.created_at || '',
  updated_at: row.updated_at || '',
  raw: row
});

export const getPlayerByName = (players = [], playerName = '') => {
  const target = normalizePlayerKey(playerName);
  if (!target) return null;

  return players.find((player) => normalizePlayerKey(player.name) === target) || null;
};

export const getPlayerOptions = (state, currentValue = '') => {
  const names = new Map();
  const add = (value) => {
    const name = normalizePlayerName(value);
    if (!name) return;
    names.set(normalizePlayerKey(name), name);
  };

  (state.players || []).forEach((player) => add(player.name));
  add(currentValue);

  return Array.from(names.values()).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
};

export const canEditCharacterAsViewer = (character, state = {}) => {
  if (state.viewMode === 'dm') return true;
  const { identity } = state;
  if (!identity || identity.isGuest) return false;
  return normalizePlayerKey(character?.player) === normalizePlayerKey(identity.name);
};

export const applyPlayersToCharacters = (characters = [], players = []) => {
  const playerMap = new Map(
    players
      .filter((player) => player?.name)
      .map((player) => [normalizePlayerKey(player.name), player])
  );

  return characters.map((character) => {
    const playerName = normalizePlayerName(character.player);
    const linkedPlayer = playerMap.get(normalizePlayerKey(playerName));
    const discordId = linkedPlayer?.discord_id || normalizeDiscordId(character.discord_id);

    return {
      ...character,
      player: playerName,
      discord_id: discordId
    };
  });
};
